import $ from 'jquery';

export function initPersonaScan() {


    $(".persona-scan-filter.select2").select2({
        minimumResultsForSearch: -1, dropdownAutoWidth: true,

    });

    $(".persona-scan-report .btn-mail-persona-report").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);

        $this.addClass("d-none");

        $(".notify-sending-email").removeClass("d-none");

        $.ajax({
            url: $this.attr("href"), method: "POST", data: {}, dataType: "json", success: function (data) {

                $(".notify-sending-email").addClass("d-none");

                if (typeof data.success != 'undefined' && data.success) {
                    $(".persona-scan-report .mail-result .feedback").removeClass("d-none");
                } else {
                    $this.removeClass("d-none");
                    $(".persona-scan-report .mail-result .error").removeClass("d-none");
                }

            }
        });

    });

}
